import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { ability } from '@oliasoft/authorization-ui';
import httpClient from '~utils/httpClient';
import { FetchPermissionsRoutine, SetUserRoutine } from './redux-routines';
import * as API from './api';
import { saveLocalStoreData } from '../../services/local-storage.service';
import { toError } from '~utils/toError';

export const fetchPermissions = () => async (dispatch: Dispatch<AnyAction>) => {
  dispatch(FetchPermissionsRoutine.request());
  try {
    const { data } = await API.fetchPermissions();
    dispatch(FetchPermissionsRoutine.success(data));
  } catch (e) {
    dispatch(FetchPermissionsRoutine.failure(toError(e)));
  }
};

export const userLoginToken = (token: string) => async (
  dispatch: Dispatch<AnyAction>,
): Promise<ReturnType<typeof ability.update> | undefined> => {
  try {
    const { data } = await httpClient({
      method: 'post',
      url: 'api/tokenlogin',
      baseURL: '/',
      data: { token },
    });
    saveLocalStoreData('permissions', data.abilities, true);
    saveLocalStoreData('user', data.user, true);

    return ability.update(data.abilities);
  } catch (err) {
    dispatch(SetUserRoutine.failure(toError(err)));
    return undefined;
  }
};
